import { SvgIconProps, SvgIconTypeMap } from "@mui/material";
import { CommonProps, OverridableComponent } from "@mui/material/OverridableComponent";
import * as React from "react";

export type MprcIconSvgProps = SvgIconProps;

interface IProps {
    icon: OverridableComponent<SvgIconTypeMap> & { muiName: string; };
}

type LocalProps = IProps & MprcIconSvgProps & CommonProps;

export const MprcIconSvg: React.FC<LocalProps> = (props) => {
    const { icon, color = "inherit", ...rest } = props;
    const SvgIcon: OverridableComponent<SvgIconTypeMap> = icon;

    return (
        <SvgIcon color={color} {...rest} />
    );
};
